import { MoveStroke } from '../types';
import { call, select } from 'redux-saga/effects';
import { MultipleOpinionScaleQuesState } from '../../../../../shared/types/QuesTypes';
import { putEffect } from '../../../../../shared/utils/putEffect';
import { setSurveyError } from '../../shared/actions';
import { setQuestion } from '../../sharedQuestions/actions';
import { set, updateAll } from 'shades';
import { move } from 'ramda';
import { getApiError } from '../../../../../shared/utils/getApiError';
import axios from '@utils/axios';
import { getApiEndPointUrl } from '../../../../../shared/utils/getApiEndpointUrl';
import { questionSectionStrokesEndPoint } from '../consts';
import { processSectionStrokes } from '../../surveyInfo/sagas/utils';

export function* reorderStrokes(action: MoveStroke) {
	const { quesId, srcIndex, destIndex, sectionId } = action.payload;
	const { questions } = yield select((s) => s.surveyBuilder);
	if (!!questions[quesId]) {
		const question: MultipleOpinionScaleQuesState = questions[quesId];

		try {
			// Performing reorder before API confirmation for smooth UX
			yield putEffect(
				setQuestion(
					question.id,
					set(
						'sections',
						sectionId,
						'strokeOrder'
					)(move(srcIndex, destIndex, question.sections[sectionId].strokeOrder))(question),
					true
				)
			);

			const { data } = yield call(
				axios.patch,
				getApiEndPointUrl(questionSectionStrokesEndPoint, question.sections[sectionId].strokeOrder[srcIndex]),
				{
					sectionId,
					orderPosition: destIndex + 1,
				}
			);
			const { strokeOrder, strokes } = processSectionStrokes(data);

			yield putEffect(
				setQuestion(
					question.id,
					updateAll<MultipleOpinionScaleQuesState>(
						set('sections', sectionId, 'strokes')(strokes),
						set('sections', sectionId, 'strokeOrder')(strokeOrder)
					)(question)
				)
			);
		} catch (e) {
			// reverting change if API request fails
			yield putEffect(setQuestion(question.id, question));
			yield putEffect(setSurveyError(getApiError(e)));
		}
	} else {
		let question: any;
		for (const questionId in questions) {
			const section = questions[questionId];
			if (section?.metaData && section?.questionnaireId.length > 0) {
				if (section?.questions?.[quesId]) {
					question = section?.questions?.[quesId];
					break;
				}
			}
		}
		try {
			// Performing reorder before API confirmation for smooth UX
			yield putEffect(
				setQuestion(
					question.id,
					set(
						'sections',
						sectionId,
						'strokeOrder'
					)(move(srcIndex, destIndex, question.sections[sectionId].strokeOrder))(question),
					true
				)
			);

			const { data } = yield call(
				axios.patch,
				getApiEndPointUrl(questionSectionStrokesEndPoint, question.sections[sectionId].strokeOrder[srcIndex]),
				{
					sectionId,
					orderPosition: destIndex + 1,
				}
			);
			const { strokeOrder, strokes } = processSectionStrokes(data);

			questions[question?.questionnaireSectionId].questions[question.id] = setQuestion(
				question.id,
				updateAll<MultipleOpinionScaleQuesState>(
					set('sections', sectionId, 'strokes')(strokes),
					set('sections', sectionId, 'strokeOrder')(strokeOrder)
				)(question)
			);

			yield putEffect(setQuestion(question?.questionnaireSectionId, questions[question?.questionnaireSectionId]));
		} catch (e) {
			// reverting change if API request fails
			yield putEffect(setQuestion(questions[question?.questionnaireSectionId], question));
			yield putEffect(setSurveyError(getApiError(e)));
		}
	}
}
